import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BaseStepProps } from '../BaseStep';

const MatchingStartsStep: React.FC<BaseStepProps> = () => {
  const navigate = useNavigate();

  React.useLayoutEffect(() => {
    navigate('/dashboard', { replace: true });
  }, [navigate]);

  return null;
};

export default MatchingStartsStep;
